import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "modal__header" };
const _hoisted_2 = { class: "modal__title" };
const _hoisted_3 = { class: "modal__content" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "modal__footer" };
const _hoisted_8 = { class: "form-buttons" };
const _hoisted_9 = ["disabled"];
import Modal from "./Modal.vue";
import Icon from "./Icon.vue";
import paloma from '../services/PalomaBackend';
import trans from '../services/Translator';
import { handleHttpError } from "../services/Alerts";
import env from "../services/AppEnv";
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfirmationDialog',
    props: {
        title: {},
        text: {},
        cancelLabel: {},
        confirmLabel: {},
        confirmIcon: {},
        dangerous: { type: Boolean },
        previewUrl: {}
    },
    emits: [
        'cancel',
        'confirm'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const http = paloma.http;
        const props = __props;
        const preview = ref(null);
        const loading = ref(false);
        const relevantDeletions = computed(() => (preview.value && preview.value.deletions) ? preview.value.deletions.filter(el => el.count > 0) : []);
        if (props.previewUrl) {
            loading.value = true;
            http.get(props.previewUrl, { params: { locale: env.locale } })
                .then(response => preview.value = response.data)
                .catch(handleHttpError)
                .finally(() => loading.value = false);
        }
        function translateDeletion(deletion) {
            deletion.type = trans(deletion.type);
            return deletion;
        }
        function cancel() {
            emit('cancel');
        }
        function confirm() {
            emit('confirm');
        }
        return (_ctx, _cache) => {
            const _directive_focus = _resolveDirective("focus");
            return (_openBlock(), _createBlock(Modal, {
                classes: { 'modal--medium': true, 'modal--confirm': true, 'modal--confirm-dangerous': __props.dangerous },
                onClose: cancel
            }, {
                body: _withCtx(() => [
                    _createElementVNode("header", _hoisted_1, [
                        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title || _ctx.$t('confirm.title')), 1)
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("section", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "text", {}, () => [
                            _createElementVNode("p", null, _toDisplayString(__props.text), 1)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (preview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (relevantDeletions.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relevantDeletions.value, (deletion, index) => {
                                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.$t('operation_preview.deletion', translateDeletion(deletion))), 1));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[2] || (_cache[2] = _createTextVNode()),
                                (preview.value.changes && preview.value.changes.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preview.value.changes, (change, index) => {
                                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                _createElementVNode("h3", null, _toDisplayString(_ctx.$t(change.type)), 1),
                                                _cache[1] || (_cache[1] = _createTextVNode()),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(change.values, (valueChange, index) => {
                                                    return (_openBlock(), _createElementBlock("dl", { key: index }, [
                                                        _createElementVNode("dt", null, _toDisplayString(_ctx.$trans(change.type + '.' + valueChange.name, undefined, valueChange.name)), 1),
                                                        _cache[0] || (_cache[0] = _createTextVNode()),
                                                        _createElementVNode("dd", null, _toDisplayString(valueChange.oldValue) + "\n                                    ⇒\n                                    " + _toDisplayString(valueChange.newValue), 1)
                                                    ]));
                                                }), 128))
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("section", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("a", {
                                class: "button button--link button--cancel",
                                onClick: _withModifiers(cancel, ["prevent"]),
                                href: ""
                            }, _toDisplayString(__props.cancelLabel || _ctx.$t('cancel')), 1),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _withDirectives((_openBlock(), _createElementBlock("button", {
                                class: _normalizeClass(["button", { 'button--primary': !__props.dangerous, 'button--danger': !!__props.dangerous }]),
                                disabled: loading.value,
                                onClick: _withModifiers(confirm, ["prevent"])
                            }, [
                                (__props.confirmIcon)
                                    ? (_openBlock(), _createBlock(Icon, {
                                        key: 0,
                                        name: __props.confirmIcon
                                    }, null, 8, ["name"]))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(__props.confirmLabel || _ctx.$t('confirm')), 1)
                            ], 10, _hoisted_9)), [
                                [_directive_focus]
                            ])
                        ])
                    ])
                ]),
                _: 3
            }, 8, ["classes"]));
        };
    }
});
